import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';

const nameSpace = 'MARKET_PAY_SURVEY_LIBRARY_SEARCH';

const initialState = {
  filtersAreOpen: false,
  facetSelection: {},
  facets: [],
  loading: false,
  loaded: true,
  error: null,
  items: [],
  query: '',
  showAddButton: true,
  filters: {},
  additionalSurveyData: [],
  facetIsCheckedByDefault: true,
  showZeros: false,
  sortBy: 'label',
  offset: 0,
  limit: 50
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.marketPaySurveyLibrarySearch
};
export const marketPaySurveyLibrarySearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    default:
      return null;
  }
}

export const reducer = marketPaySurveyLibrarySearch.createReducer(extendReducer, {
  searchAPI: '/api/slu/search/search'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const marketPaySurveyLibrarySearchActions = marketPaySurveyLibrarySearch.getActions();
